export default __webpack_public_path__ + "static/media/ift.77b0ebe4.pdf";